import React from 'react';
import { FormattedMessage } from 'react-intl';

import './external-challenge.scss';

const ExternalChallenge = ({ externalLogo }) => (
	<div className="external-challenge">
		<FormattedMessage
			id="external.icon.label"
		/>
		<img src={externalLogo} alt="" />
	</div>
);

export default ExternalChallenge;
